import React from 'react';
import type { Project } from '../../models/projects/project';
import CardRibbon from './cardRibbon';
import CardDescription from './cardDescrition';
import CardProgress from './cardProgress';
import CardStatus from './cardStatus';
import CardAchievement from './cardAchievement';
import CardPercentage from './cardPercentage';
import CardSpecificInvestor from './cardSpecificInvestor';

interface Props {
  project: Project;
  speficInvestorFlg: boolean;
}

export default function Card({ project, speficInvestorFlg }: Props) {
  return (
    <div className="col-md-6 mb-30">
      <div className="projects card">
        <CardRibbon project={project} />
        {project.caseStudiesSize > 0 && (
          <div className="interview">
            <div className="title">
              <i className="fas fa-microphone pr-5" />
              インタビューあり
            </div>
          </div>
        )}
        <div className="card-img">
          <a href={`/projects/${project.id}`} rel="noopener noreferrer">
            <img
              className="card-img-top"
              alt={project.name}
              src={project.image.thumb16By9.url}
            />
          </a>
        </div>
        <div className="card-body">
          <div className="company media">
            <img
              width="64"
              className="media-object"
              src={project.company.imageThumbUrl}
            />
            <div className="media-body">
              <span className="text-muted company-name">
                {project.originalCompanyName
                  ? project.originalCompanyName
                  : project.company.name}
              </span>
            </div>
          </div>
          <h5 className="card-title">
            <a href={`/projects/${project.id}`} rel="noopener noreferrer">
              {project.name}
            </a>
          </h5>
          <CardDescription project={project} />
          <CardAchievement project={project} />
          <CardProgress project={project} />
          {speficInvestorFlg && (
            <CardSpecificInvestor project={project}></CardSpecificInvestor>
          )}
          <CardPercentage project={project} />
          <CardStatus project={project} />
        </div>
      </div>
    </div>
  );
}
